import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { GenerateThumbnailDto } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const modifyThumbnail = async ({
  orgId,
  data,
}: {
  orgId: string;
  data: GenerateThumbnailDto;
}): Promise<string> => {
  const response = await axiosClient.post(
    `/${orgId}/recordings/generate-thumbnail`,
    data,
  );
  return response.data;
};

function useModifyThumbnail(
  mutationOptions?: Partial<
    UseMutationOptions<
      string,
      HttpError,
      { data: GenerateThumbnailDto; orgId: string }
    >
  >,
) {
  return useMutation({
    mutationFn: ({ data, orgId }) => modifyThumbnail({ data, orgId }),
    ...mutationOptions,
  });
}
export { useModifyThumbnail };
